import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import {Link as RouterLink, withRouter} from "react-router-dom";
import { withSnackbar } from "notistack";
import classNames from "classnames";
import moment from "moment";
import {
  withStyles,
  Chip,
  Grid,
  IconButton,
  Switch,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputBase,
  InputAdornment,
  FormControlLabel, TextField, MenuItem, Table, TableHead, TableRow, TableCell, TableBody, Typography, TableContainer,
  CircularProgress,
} from "@material-ui/core";
import { Layout, SimpleBreadcrumbs, Panel } from "../../components";
import {
  setLoading,
  fetchPatientStates,
} from "../../redux/actions/globalActions";
import {
  getBatchShippingStatus,
} from "../../redux/actions/shippingStatusActions";
import PdfIcon from "@material-ui/icons/CloudDownload";

import { KeyboardDatePicker } from "@material-ui/pickers";
import styles from "./styles";
import { getOrder } from "../../redux/actions/orderActions";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {AttachFile, Delete, Edit, Search, Today} from "@material-ui/icons";
import TableResponsive from "../../components/TableResponsive";
import _debounce from "lodash/debounce";
import Autocomplete from "../../components/Autocomplete";
import Link from "@material-ui/core/Link";

const breadcrumbs = [
  { name: "Home", to: "/home" },
  { name: "Large Batch View", to: null },
];

class LargeBatchList extends React.Component {
  state = {
    downloadingBatchId: null,
  };

  componentDidMount = async () => {
    try {
      await this.fetchShippingStatus();
    } catch (error) {
      console.error(error);
    }
  };

  fetchShippingStatus = () => {
    return this.props.getBatchShippingStatus();
  };

  fetchShippingStatusDelayed = _debounce((e) => {
    return this.getBatchShippingStatus();
  }, 1500);

  downloadBatchPDF = async (batchId, batchName) => {
    try {
      this.setState({ downloadingBatchId: batchId });
      this.props.enqueueSnackbar('Generating PDF, please wait...', { variant: 'info' });

      const authData = localStorage.getItem('auth');
      const auth = authData ? JSON.parse(authData) : null;
      const token = auth ? auth.token : null;
      
      if (!token) {
        this.props.enqueueSnackbar('Authentication required', { variant: 'error' });
        this.setState({ downloadingBatchId: null });
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/confirm_export_batch/?batchPrintId=${batchId}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `JWT ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${batchName}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      this.props.enqueueSnackbar('PDF downloaded successfully', { variant: 'success' });
    } catch (error) {
      console.error('Error downloading PDF:', error);
      this.props.enqueueSnackbar('Error downloading PDF', { variant: 'error' });
    } finally {
      this.setState({ downloadingBatchId: null });
    }
  };

  render() {
    let {
      classes,
      batches,
    } = this.props;

    return (
      <Layout title="List Batch Print">
        <SimpleBreadcrumbs routes={breadcrumbs} />
        <Panel>
          <div className={classes.tableContainer}>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Download</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {batches.map(batch => (
                      <TableRow key={batch.name}>
                        {/*<TableCell component="th" scope="row" align="left">*/}
                        {/*  {profile.first_name || " "} {profile.middle_name || " "}{" "}*/}
                        {/*  {profile.last_name || ""}*/}
                        {/*</TableCell>*/}
                        <TableCell>
                          <AttachFile />
                          <Link
                              className={classes.link}
                              onClick={(e) => {
                                e.preventDefault();
                                if (this.state.downloadingBatchId !== batch.id) {
                                  this.downloadBatchPDF(batch.id, batch.name);
                                }
                              }}
                              style={{ cursor: this.state.downloadingBatchId === batch.id ? 'wait' : 'pointer' }}
                          >
                            {batch.name}
                          </Link>
                          {this.state.downloadingBatchId === batch.id && (
                            <CircularProgress size={20} style={{ marginLeft: 10 }} />
                          )}
                        </TableCell>

                      </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Panel>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    batches: state.batch_list.list,
    loading: state.global.loading,
  }
};

const mapDispatchToProps = {
  getBatchShippingStatus
};

export default compose(
  withRouter,
  withSnackbar,
  withStyles(styles, { name: "LargeBatchList" }),
  connect(mapStateToProps, mapDispatchToProps)
)(LargeBatchList);
